import { render } from "./IntersectionObserver.vue?vue&type=template&id=670b9e04"
import script from "./IntersectionObserver.vue?vue&type=script&lang=js"
export * from "./IntersectionObserver.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__